import { useDispatch } from '@globalStore/storeProvider';
import { CheckIcon } from '@heroicons/react/solid';
import React, { useState } from 'react';
import Carousel from 'react-multi-carousel';
import { Primary } from 'stories/Button.stories';
const icon1 = '/assets/icons/money.svg';
const icon2 = '/assets/icons/calendar.svg';
const icon3 = '/assets/icons/job.svg';

const carouselContent = [
  {
    title: ['Pay After', 'Placement - No Job,', 'No Payment!'],
    points: ['Zero Upfront Cost', 'Risk-Free Learning'],
    icon: <img src={icon1} className="h-5 w-5 text-[#FF784C]" />,
  },
  {
    title: ['Easy EMIs – Just', '₹10K/Month!'],
    points: ['Start Paying Only After Earning', 'Pocket-Friendly EMIs'],
    icon: <img src={icon3} className="h-5 w-5 text-[#FF784C]" />,
  },
  {
    title: ['Salary-Based,', 'Stress-Free', 'Payments'],
    points: ['100% Transparency', 'Fixed EMIs, No Surprises'],
    icon: <img src={icon2} className="h-5 w-5 text-[#FF784C]" />,
  },
];

const CarrerServiceFee = ({ planDetails }) => {
  const dispatch = useDispatch();

  return (
    <>
      <div className="service-fee mb-8 -mt-12 flex w-full flex-col items-center justify-center gap-6 p-1 md:gap-16 md:p-4 xl:flex-row">
        <div className="w-full md:w-[30%]">
          <CarouselComponent />
        </div>
        <div className="w-full overflow-x-auto p-1 md:w-[70%] md:p-4 lg:max-w-[500px] xl:max-w-[600px]">
          <PricingTable />
        </div>
      </div>
      <p className="mb-6 text-center font-gellix-uniform text-[16px] font-normal leading-[150%] text-[#1F1F1F]">
        Success first, placement fee later — only at AlmaBetter!
      </p>

      <div className="flex justify-center">
        <Primary
          label="Talk To Admission Team"
          onClick={() =>
            dispatch({
              type: 'SET_WIDGET_SOURCE',
              payload: 'request_call_back_widget',
            })
          }
        />
      </div>
    </>
  );
};

export default CarrerServiceFee;

function PricingTable() {
  const [hover, setHover] = useState(null);
  const Details = [
    { package: '< 3.5 LPA', pap: '₹0', tenure: 'NA', icon: true },
    { package: '3.5 - 4.99 LPA', pap: '₹6,000 x 20 Months', tenure: '20 months', icon: true },
    { package: '5 - 7.99 LPA', pap: '₹8,000 x 20 Months', tenure: '20 months', icon: true },
    { package: '> 8 LPA', pap: '₹10,000 x 20 Months', tenure: '20 months', icon: true },
  ];
  return (
    <table className="w-full max-w-full table-fixed border-collapse">
      <thead>
        <tr className="text-left text-xs font-normal text-neutral-700">
          <th className="relative w-1/2 p-2 text-center font-gellix-uniform font-normal leading-[150%] [font-feature-settings:'liga'_off,'clig'_off] md:p-2 md:text-[18px] md:leading-[24px]">
            <span className="relative inline-block pb-3 after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-full after:bg-[#fee2e2]">
              Package Range (CTC)
            </span>
          </th>
          <th className="relative w-1/2 p-2 text-center font-gellix-uniform font-normal leading-[150%] [font-feature-settings:'liga'_off,'clig'_off] md:p-2 md:text-[18px] md:leading-[24px]">
            <span className="relative inline-block pb-3 text-center after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-full after:bg-[#fee2e2]">
              EMI Plan
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        {Details.map((item, index) => (
          <tr
            key={index}
            className={` border-none ${
              index === 2
                ? 'rounded-md bg-[#FFE5EB] shadow-[0px_2px_8px_0px_rgba(255,211,199,0.32)]'
                : ''
            } `}
            onMouseEnter={() => setHover(index)}
            onMouseLeave={() => setHover(null)}
          >
            <td
              className={`font-gellix-regular-italic p-1 text-center text-[13px] font-semibold leading-[150%] transition-all duration-300 md:p-3 md:text-[16px] md:leading-[24px] ${
                index === 2 ? 'scale-105 rounded-l-lg font-semibold text-red' : 'text-gray-800'
              } `}
            >
              {item.package}
            </td>
            <td
              className={`font-gellix-regular-italic p-1 text-center text-[13px] leading-[150%] text-gray-800 md:p-3 md:text-[16px] md:leading-[24px] ${
                index === 2 ? 'font-semibold' : ''
              }`}
            >
              {item.pap}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function CarouselComponent() {
  // Carousel settings
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 679 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 678, min: 0 },
      items: 1,
    },
  };

  const EmiCard = ({ data, className }) => {
    return (
      <div className={`${className}`}>
        <div
          className={`to-red-50 relative flex w-40 flex-col rounded-xl bg-white bg-gradient-to-br from-white via-white to-rose-100 py-3 px-4 shadow-[0px_2px_12px_0px_rgba(240,0,55,0.08)]`}
        >
          {data?.title.map((data) => (
            <div key={data} className="text-xs font-semibold text-stone-900 sm:text-sm">
              {data}
            </div>
          ))}
          <div className="mt-3 flex flex-col gap-2">
            {data?.points?.map((data) => (
              <div
                key={data}
                className="flex items-center gap-2 text-xs font-medium leading-none text-stone-900"
              >
                <CheckIcon className="h-4 w-4 text-[#FF784C]" style={{ minWidth: '16px' }} />
                <div>{data}</div>
              </div>
            ))}
          </div>
          <div className="absolute top-0 right-0 flex -translate-y-[40%] translate-x-[40%] items-center justify-center rounded-full bg-white p-2 shadow-lg">
            {data?.icon}
          </div>
        </div>
      </div>
    );
  };

  // Custom dot component
  const CustomDot = ({ onClick, active }) => {
    return (
      <button
        onClick={onClick}
        className={`rounded-full transition-colors duration-300 ${
          active ? 'h-[6px] w-[6px] bg-red' : 'h-[4px] w-[4px] bg-[#DCDCDC]'
        }`}
      />
    );
  };

  return (
    <div className="relative w-full bg-none shadow-none">
      <Carousel
        responsive={responsive}
        autoPlay
        infinite
        showDots
        arrows={false}
        customDot={<CustomDot />}
        containerClass="relative w-full sm:w-72 xl:w-full h-64"
        dotListClass="flex gap-1 items-center justify-center"
      >
        {[1, 2, 3].map((index) => (
          <div key={index} className="relative h-[260px]">
            <div className="absolute right-10 h-full w-[70%] overflow-visible rounded-[12px] bg-gradient-to-b from-[#ffffff] to-[#FFD6CA]"></div>

            <img
              alt=""
              src={`/assets/serviceFeesAvatar${index}.png`}
              className="absolute bottom-0 left-0 z-50 object-cover"
            />

            <EmiCard
              className={'absolute right-4 top-[10%] z-50'}
              data={carouselContent[index - 1]}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
}
